import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { BsArrowRightCircle } from "react-icons/bs";
import headerImg from "../assets/img/women-web-developer-with-laptop.svg";
import TrackVisibility from "react-on-screen";

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState("");
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const [index, setIndex] = useState(1);
  const toRotate = ["Frontend Dev", "Backend Dev"];
  const period = 200;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => {
      clearInterval(ticker);
    };
  }, [text]);

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta((prevDelta) => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex((prevIndex) => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === "") {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(500);
    } else {
      setIndex((prevIndex) => prevIndex + 1);
    }
  };

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} xl={7}>
            <div>
              <span className="tagline">Hello!</span>
              <h1>
                {`I'm Suzuka, a `}
                <span className="wrap">Full Stack Developer</span>
              </h1>
              <p>
                I used to be a translator, then decided to pursue my dream to be
                a software developer after I moved to Sydney in 2019! I am very
                passionate about both front and back-end technologies, and never
                get tired of learning new things :)
              </p>
            </div>
            <a className="email" href="mailto:suzuka.fukami@gmail.com">
              Let's connect
              <BsArrowRightCircle size={30} />
            </a>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <img src={headerImg} alt="woman web developer with laptop" />
            <div className="img-credit">
              <a
                href="https://iconscout.com/illustrations/women"
                target="_blank"
              >
                Image
              </a>{" "}
              by{" "}
              <a
                href="https://iconscout.com/contributors/woobrodesign"
                target="_blank"
              >
                WOOBRO LTD
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
